import { Component, OnInit } from '@angular/core';
import { ProjectDetailInstance } from '../project-detail.instance';
import { ObjectService } from '../../../shared/object.service';
import { PObject } from '../../../models/object';
import { Project } from '../../../models/project';
import { EditObjectModalComponent } from '../../edit-object-modal/edit-object-modal.component';
import { ModalService } from '../../../core/modal.service';
import { ImportObjectsModalComponent } from './import-objects-modal/import-objects-modal.component';

@Component({
  selector: 'app-project-detail-objects',
  templateUrl: './project-detail-objects.component.html',
  styleUrls: ['./project-detail-objects.component.scss']
})
export class ProjectDetailObjectsComponent implements OnInit {
  objects: PObject[];
  selected: PObject[] = [];
  project: Project;

  constructor(private instance: ProjectDetailInstance,
              private objectService: ObjectService,
              private modal: ModalService) {
  }

  ngOnInit() {
    this.instance.$project.subscribe(project => {
      if (project) {
        this.project = project;
        this.loadObjects();
      }
    });
  }

  showAdd() {
    const modalRef = this.modal.open(EditObjectModalComponent);
    modalRef.componentInstance.init(this.project);

    modalRef.result.then((project) => {
      this.loadObjects();
    }, (reason) => {

    }).catch(() => {
    });
  }

  showImport() {
    const modalRef = this.modal.open(ImportObjectsModalComponent);
    modalRef.componentInstance.init(this.project);

    modalRef.result.then((project) => {
      this.loadObjects();
    }, (reason) => {

    }).catch(() => {
    });
  }

  onToggle(object: PObject) {
    let idx = this.selected.findIndex(o => o.id === object.id);
    if (idx > -1) {
      this.selected.splice(idx, 1);
    } else {
      this.selected.push(object);
    }
  }

  isChecked(object: PObject) {
    return this.selected.findIndex(o => o.id === object.id) > -1;
  }

  private loadObjects() {
    this.objectService.get(this.project).subscribe(objects => {
      this.objects = objects;
    });
  }

  deleteSelected() {
    const ids = this.selected.map(o => o.id);

    this.objectService.deleteMany(this.project, ids).subscribe(ok => {
    });
  }

  showEdit(object: PObject) {
    const modalRef = this.modal.open(EditObjectModalComponent);
    modalRef.componentInstance.init(this.project, object);

    modalRef.result.then((project) => {
      this.loadObjects();
    }, (reason) => {

    }).catch(() => {
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/projects/detail/project-detail-objects/project-detail-objects.component.ts